var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('rex-document'),(_vm.pageMode === _vm.PageModeType.OK)?_c('router-view',{key:_vm.$route.meta.key || _vm.$route.name}):(_vm.pageMode === _vm.PageModeType.PAGE_NOT_FOUND)?_c('frp-page-not-found'):(_vm.pageMode === _vm.PageModeType.ACCESS_DENIED)?_c('frp-access-denied-error'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }